import DeliveryInput from './DeliveryInput';

export default DeliveryInput;
